/**
 * resolveHostedConfig — flags win over env, mirroring resolveWatchConfig.
 *
 * The mission-control subcommands (directive / prompt / ticket) all need a
 * hosted base URL + token. This centralizes the resolution + the friendly
 * missing-key error so each handler stays thin.
 */

export interface HostedFlags {
  url?: string;
  token?: string;
}

export interface HostedConfig {
  baseUrl: string;
  token: string;
}

export function resolveHostedConfig(
  flags: HostedFlags,
  env: { AETHEREUM_SYNC_API_URL?: string; AETHEREUM_SYNC_TOKEN?: string } = process.env,
): HostedConfig | { error: string } {
  const baseUrl = flags.url ?? env.AETHEREUM_SYNC_API_URL;
  const token = flags.token ?? env.AETHEREUM_SYNC_TOKEN;
  if (!baseUrl || !token) {
    return {
      error:
        "mission control needs a hosted room: run 'aethereum init --token <key>' or set " +
        "AETHEREUM_SYNC_API_URL + AETHEREUM_SYNC_TOKEN (or pass --url and --token).",
    };
  }
  return { baseUrl: baseUrl.replace(/\/$/, ""), token };
}
